// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-spinner {
  margin: 32px;
  height: 72px;
  width: 72px;
}

.payment-input {
  margin: 6px 12px;
  background: var(--payment-modal-item-background, white);
  border-radius: 5px;
  padding: var(--ion-margin);
  color: var(--ion-color-black);
}

.header-msg {
  font-size: 18px;
  font-family: AppFontSemiBold, sans-serif;
}

.payment-method-row {
  min-height: 56px;
  align-items: center;
  margin: 6px 12px;
  background: white;
  border-radius: 5px;
}
.payment-method-row > ion-col {
  padding: 0;
}
.payment-method-row > ion-col ion-item {
  overflow: hidden;
  --background: #00000000;
}
.payment-method-row > ion-col ion-item > ion-radio {
  --color: var(--ion-color-primary);
  --color-checked: var(--ion-color-primary);
  margin: 11px 16px 10px 4px;
}
.payment-method-row > ion-col ion-item > ion-label {
  color: var(--ion-color-black);
  font-weight: bold;
}

.back-icon {
  margin-right: 10px;
  width: 30px;
}

.bottom-end {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 300px;
  width: 142px;
}

.padding-5 {
  padding: 5px;
}

ion-content {
  --background: #f9f9f9;
}

.icon-size {
  margin: 0px;
  zoom: var(--payment-icon-size);
}

.log {
  height: 200px;
  width: 200px;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9999;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/smoothr-web-app-core/components/payment-modal/payment-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,YAAA;EACA,WAAA;AACD;;AAEA;EACC,gBAAA;EACA,uDAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;AACD;;AAEA;EACC,eAAA;EACA,wCAAA;AACD;;AAEA;EACC,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACD;AACC;EACC,UAAA;AACF;AACE;EACC,gBAAA;EACA,uBAAA;AACH;AACG;EACC,iCAAA;EACA,yCAAA;EACA,0BAAA;AACJ;AAEG;EACC,6BAAA;EACA,iBAAA;AAAJ;;AAMA;EACC,kBAAA;EACA,WAAA;AAHD;;AAMA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;AAHD;;AAMA;EACC,YAAA;AAHD;;AAMA;EACC,qBAAA;AAHD;;AAMA;EACC,WAAA;EACA,8BAAA;AAHD;;AAMA;EACC,aAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;AAHD","sourcesContent":["ion-spinner {\n\tmargin: 32px;\n\theight: 72px;\n\twidth: 72px;\n}\n\n.payment-input {\n\tmargin: 6px 12px;\n\tbackground: var(--payment-modal-item-background, white);\n\tborder-radius: 5px;\n\tpadding: var(--ion-margin);\n\tcolor: var(--ion-color-black);\n}\n\n.header-msg {\n\tfont-size: 18px;\n\tfont-family: AppFontSemiBold, sans-serif;\n}\n\n.payment-method-row {\n\tmin-height: 56px;\n\talign-items: center;\n\tmargin: 6px 12px;\n\tbackground: white;\n\tborder-radius: 5px;\n\n\t> ion-col {\n\t\tpadding: 0;\n\n\t\tion-item {\n\t\t\toverflow: hidden;\n\t\t\t--background: #00000000;\n\n\t\t\t> ion-radio {\n\t\t\t\t--color: var(--ion-color-primary);\n\t\t\t\t--color-checked: var(--ion-color-primary);\n\t\t\t\tmargin: 11px 16px 10px 4px;\n\t\t\t}\n\n\t\t\t> ion-label {\n\t\t\t\tcolor: var(--ion-color-black);\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.back-icon {\n\tmargin-right: 10px;\n\twidth: 30px;\n}\n\n.bottom-end {\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\theight: 300px;\n\twidth: 142px;\n}\n\n.padding-5 {\n\tpadding: 5px;\n}\n\nion-content {\n\t--background: #f9f9f9;\n}\n\n.icon-size {\n\tmargin: 0px;\n\tzoom: var(--payment-icon-size);\n}\n\n.log {\n\theight: 200px;\n\twidth: 200px;\n\tposition: fixed;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 9999;\n\toverflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
